import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

import { FullScreenSpinner } from '../../../components/Spinner/Spinner';
import { useAppDispatch } from '../../../store';
import { setAuthToken } from '../../auth/state/authSlice';
import { getErrorMessage } from '../../../utils';
import { useLazyTradeLoginQuery } from '../api/tradeApi';

export const TradeLoginToken = () => {
  const navigate = useNavigate();
  const [login] = useLazyTradeLoginQuery();
  const { token = '' } = useParams();
  const dispatch = useAppDispatch();

  const checkToken = async () => {
    try {
      const res = await login({ token }).unwrap();
      dispatch(setAuthToken(res.token));
      toast('Login successful', { type: 'success' });
      navigate('/trade/dashboard');
    } catch (err) {
      const errString = getErrorMessage(err, "Couldn't log in, please try again");
      toast(errString, { type: 'error' });
      navigate('/trade');
    }
  };

  useEffect(() => {
    if (token) {
      checkToken();
    }
  }, [token]);

  return (
    <div>
      <FullScreenSpinner />
    </div>
  );
};
